// Desktop-only decorative amino acid banner.

const SEQ_FILES = [
  '/sequences/placeholder1.txt',
  '/sequences/placeholder2.txt',
  '/sequences/placeholder3.txt'
];

const DISPLAY_SEQ_LEN = 520;

function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

function randInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

// Generate non-overlapping colored segments across the sequence
function makeSegments(n, opts = {}) {
  const {
    minLen = 10,
    maxLen = 40,
    coverage = 0.35, // ~35% of sequence colored
  } = opts;

  const segs = [];
  let covered = 0;
  let i = 0;
  // Walk forward to avoid overlaps; randomly skip gaps
  while (i < n && covered / n < coverage) {
    // random gap before next domain
    i += randInt(5, 35);
    if (i >= n) break;
    const len = Math.min(randInt(minLen, maxLen), n - i);
    segs.push([i, i + len]);
    covered += len;
    i += len;
  }
  return segs;
}

function randomColorHsla() {
  const hue = randInt(0, 359);
  const sat = randInt(45, 75);
  const light = randInt(55, 70);
  const alpha = 0.5;
  return `hsla(${hue} ${sat}% ${light}% / ${alpha})`;
}

function randomSequenceWindow(seq) {
  if (!seq) return '';
  const start = randInt(0, Math.max(0, seq.length - 1));
  const rotated = `${seq.slice(start)}${seq.slice(0, start)}`;
  let out = rotated;
  while (out.length < DISPLAY_SEQ_LEN) {
    out += rotated;
  }
  return out.slice(0, DISPLAY_SEQ_LEN);
}

function colorizeSequence(seq) {
  const L = seq.length;
  const segments = makeSegments(L, { minLen: 12, maxLen: 48, coverage: 0.4 });
  // Assign a color per segment
  const colors = segments.map(() => randomColorHsla());

  // Build HTML by chunks to avoid per-letter span overhead
  let html = '';
  let cursor = 0;
  segments.forEach(([s, e], idx) => {
    if (s > cursor) {
      html += seq.slice(cursor, s);
    }
    const colored = seq.slice(s, e);
    const color = colors[idx];
    html += `<span class="aa-dom" style="color:${color}">${colored}</span>`;
    cursor = e;
  });
  if (cursor < L) html += seq.slice(cursor);
  return html;
}

async function initBanner() {
  // Skip only on true small screens; otherwise allow if there's room
  const small = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  if (small) return;

  const host = document.querySelector('.aa-banner');
  if (!host) return;
  // If the banner area is too narrow, skip work
  if (host.offsetWidth < 160) return;
  const seq1 = document.querySelector('.aa-seq-1');
  const seq2 = document.querySelector('.aa-seq-2');
  if (!seq1 || !seq2) return;

  try {
    const file = pick(SEQ_FILES);
    const resp = await fetch(file, { cache: 'no-store' });
    if (!resp.ok) throw new Error('sequence fetch failed');
    const raw = (await resp.text()).toUpperCase();
    // Keep only AA letters
    const seq = raw.replace(/[^ACDEFGHIKLMNPQRSTVWY]/g, '');
    if (!seq || seq.length < 80) return; // too short to look good

    const base = randomSequenceWindow(seq);
    const colored = colorizeSequence(base);

    seq1.innerHTML = colored;
    seq2.textContent = '';
  } catch (e) {
    // Decorative only; fail silently
  }
}

document.addEventListener('DOMContentLoaded', initBanner);
